import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getReportAttendanceHostStatus = async () => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `attendance-report/host/status/list` });
  
  return data;
};

export default getReportAttendanceHostStatus;
